export default function createSmoothTransitionStyles(...cssProps: string[]) {
    return {
        transitionProperty: cssProps.join(','),
        transitionDuration: '300ms',
        transitionTimingFunction: 'cubic-bezier(0.2, 0, 0, 1)',
        transitionDelay: '0s',
    };
}
